import config from 'config';

export const log = (message = '') => {
  if (process.env.NODE_ENV !== 'production') {
    console.log(`%c${ message }`, 'color: blue; font-size: 12px; font-weight: bold;');
  }
};

export const lsLog = (main = '', optional = {}) => {
  if (config.enable_ls_logs === '1') {
    console.log(`%c[VideoProvider] ${ main }`, 'color: #B56666; font-size: 13px; font-weight: bold;');
    if (Object.keys(optional).length) console.log(optional);
  }
};

export const lsErrorLog = (message = '', err) => {
  if (config.enable_ls_logs === '1') {
    console.log(`%c${ message }`, 'color: red; font-size: 14px; font-weight: bold;', err);
  }
};

export const errorLog = (message = '', err) => {
  if (process.env.NODE_ENV !== 'production') {
    console.log(`%c${ message }`, 'color: red; font-size: 14px; font-weight: bold;', err);
  }
};
